<button class="tt--button button--blue large-2x" [ngClass]="class" type="{{type}}" (click)="onButtonClicked($event)" [ngClass]="{ disabled: currentlyDisabled }" >
  @if (!currentlyLoading) {
    <span><ng-content></ng-content></span>
  }
  @if (currentlyLoading) {
    <span><i class="fa fa-spinner fa-spin fa-fw"></i> Working...</span>
  }
</button>
